const handleChanelTile_dt = (jsonData) => {
    if (jsonData.beginIndex == '1' && (jsonData.pageSize*1) < $("figure").length) $("figure").last().parents("li").hide();
};

const handleChanelTile_mobile = (jsonData) => {
	if (jsonData.beginIndex == '1' && (jsonData.pageSize*1) < $("figure").length) $("figure").last().parents("li").hide();
};

export {
    handleChanelTile_dt,
    handleChanelTile_mobile
}
